import React, { useState, useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Col, Form, Input, Label, Row } from 'reactstrap';
import Loader from 'react-loader-spinner';

import DefaultModal from '../../../../components/Modal/DefaultModal';
import AssessmentService from '../service';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';
import { FaReceipt } from 'react-icons/fa';
import StyledInput, { StyledStrong } from './style';
import { AudioStreamPlayer } from 'components/AudioController/AudioStreamPlayer';
import FlexSelect from 'components/Inputs/FlexSelect';
import FeedbackForm from './FeedbackForm';

const loaderContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

export default function AnswersModal({
  assessmentId,
  cdrUniqueId,
  MonitoringForm,
  nameAgent,
  calldateStartAnswers,
  Origem,
  Queue,
  feedback,
  onFeedbackSaved
}) {
  const [assessmentData, setAssessmentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const { control } = useForm();

  const questionGroups = useMemo(() => {
    if (
      !assessmentData?.paper?.questionGroups ||
      !assessmentData?.paper?.questions
    ) {
      return [];
    }

    const enabledQuestions = assessmentData.paper.questions.filter(
      (q) => q.enabled
    );

    if (
      assessmentData.paper.questionGroups &&
      assessmentData.paper.questionGroups.length > 0
    ) {
      const enabledGroups = assessmentData.paper.questionGroups
        .filter((g) => g.enabled)
        .sort((a, b) => a.id - b.id);

      return enabledGroups
        .map((group) => {
          const groupQuestions = enabledQuestions.filter(
            (q) => q.group_id === group.id
          );

          return {
            id: group.id,
            name: group.name,
            questions: groupQuestions
          };
        })
        .filter((group) => group.questions.length > 0);
    }

    const groupsMap = new Map();

    enabledQuestions.forEach((question) => {
      if (question.group_id) {
        if (!groupsMap.has(question.group_id)) {
          groupsMap.set(question.group_id, {
            id: question.group_id,
            name: `Grupo ${question.group_id}`,
            questions: []
          });
        }
        groupsMap.get(question.group_id).questions.push(question);
      }
    });

    return Array.from(groupsMap.values()).sort((a, b) => a.id - b.id);
  }, [assessmentData]);

  const toggle = () => {
    setModal(!modal);
  };

  const loadScores = () => {
    if (!assessmentId) return;

    setLoading(true);

    AssessmentService.getAssessmentAnswers(assessmentId)
      .then((response) => {
        console.log(response);
        setAssessmentData(response.data.data);
      })
      .catch((error) => {
        const msg =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Erro ao recuperar respostas';

        toast.error(msg, {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const renderQuestionInputs = (question, score) => {
    if (question.type === 'CRITICAL') {
      return (
        <Controller
          render={(props) => (
            <>
              <div className="d-flex flex-column align-items-center">
                <StyledInput
                  {...props}
                  id={`${question.id}_0`}
                  type="radio"
                  value={1}
                  checked={score?.total == 1}
                  disabled={true}
                />
                <Label htmlFor={`${question.id}_0`}>Não</Label>
              </div>
              <div className="d-flex flex-column align-items-center">
                <StyledInput
                  {...props}
                  id={`${question.id}_1`}
                  type="radio"
                  value={0}
                  checked={score?.total == 0}
                  disabled={true}
                />
                <Label htmlFor={`${question.id}_1`}>Sim</Label>
              </div>
            </>
          )}
          control={control}
          name={`${question.id}`}
          rules={{ required: true }}
        />
      );
    }

    if (
      assessmentData.paper?.type === 'basic' &&
      question.type === 'WEIGHTAGE'
    ) {
      return (
        <Controller
          render={(props) => (
            <>
              {[1, 2, 3, 4, 5].map((value) => (
                <div
                  key={value}
                  className="d-flex flex-column align-items-center"
                >
                  <StyledInput
                    {...props}
                    id={`${question.id}_${value}`}
                    type="radio"
                    value={value}
                    checked={score?.total == value}
                    disabled={true}
                  />
                  <Label htmlFor={`${question.id}_${value}`}>{value}</Label>
                </div>
              ))}
              {!question.required && (
                <div className="d-flex flex-column align-items-center">
                  <StyledInput
                    {...props}
                    id={`${question.id}_exclude`}
                    type="radio"
                    value={-1}
                    checked={score?.total === -1}
                    disabled={true}
                  />
                  <Label htmlFor={`${question.id}_exclude`}>
                    Não se aplica
                  </Label>
                </div>
              )}
            </>
          )}
          control={control}
          name={`${question.id}`}
          rules={{ required: true }}
        />
      );
    }

    if (
      assessmentData.paper?.type === 'advanced' &&
      question.type === 'WEIGHTAGE'
    ) {
      return (
        <Controller
          render={(props) => (
            <>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value) => (
                <div
                  key={value}
                  className="d-flex flex-column align-items-center"
                >
                  <StyledInput
                    {...props}
                    id={`${question.id}_${value}`}
                    type="radio"
                    value={value}
                    checked={score?.total == value}
                    disabled={true}
                  />
                  <Label htmlFor={`${question.id}_${value}`}>{value}</Label>
                </div>
              ))}
              {!question.required && (
                <div className="d-flex flex-column align-items-center">
                  <StyledInput
                    {...props}
                    id={`${question.id}_exclude`}
                    type="radio"
                    value={-1}
                    checked={score?.total === -1}
                    disabled={true}
                  />
                  <Label htmlFor={`${question.id}_exclude`}>
                    Não se aplica
                  </Label>
                </div>
              )}
            </>
          )}
          control={control}
          name={`${question.id}`}
          rules={{ required: true }}
        />
      );
    }
  };

  return (
    <div>
      <Button
        color={feedback ? 'primary' : 'success'}
        onClick={toggle}
        size="sm"
      >
        <FaReceipt size={17} />
      </Button>

      <DefaultModal
        show={modal}
        onModalToggle={() => {
          if (modal && !assessmentData) {
            loadScores();
          }
        }}
        title={
          assessmentData ? assessmentData.paper.name : 'Monitoria de qualidade'
        }
        modalContainerClasses="modal-lg"
        showCloseButton={true}
      >
        {loading ? (
          <div style={loaderContainerStyle}>
            <Loader type="TailSpin" color="#9ab744" height={50} width={50} />
          </div>
        ) : (
          <div>
            <AudioStreamPlayer
              uniqueid={cdrUniqueId}
              MonitoringForm={MonitoringForm}
              nameAgent={nameAgent}
              calldateStartAnswers={calldateStartAnswers}
              Origem={Origem}
              Queue={Queue}
            />
            <Form className="needs-validation">
              {assessmentData.category ? (
                <div className="mb-2">
                  <h4>{`Categoria:`}</h4>
                  <Controller
                    render={(props) => (
                      <FlexSelect
                        dataOptions={[
                          {
                            value: assessmentData.category.name
                          }
                        ]}
                        closeMenuOnSelect={true}
                        value={props.value}
                        fieldName={props.name}
                        placeholder="Categoria"
                        labelName="value"
                        valueName="value"
                        isDisabled={true}
                      />
                    )}
                    control={control}
                    name={`category`}
                    rules={{
                      required: false
                    }}
                    disabled={true}
                    defaultValue={assessmentData.category.name}
                  />
                </div>
              ) : null}

              {assessmentData.description ? (
                <div>
                  <h4>{`Descrição:`}</h4>
                  <Controller
                    as={
                      <Input
                        type="textarea"
                        rows={6}
                        style={{ margin: '0px 0px 30px' }}
                      />
                    }
                    control={control}
                    name={`description`}
                    disabled={true}
                    defaultValue={assessmentData.description}
                    placeholder="Descrição"
                  />
                </div>
              ) : null}

              {questionGroups.length > 0
                ? questionGroups.map((group) => (
                    <div
                      key={group.id}
                      className="mb-4 p-3"
                      style={{
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #dee2e6',
                        borderRadius: '8px'
                      }}
                    >
                      <Row className="mb-3">
                        <Col md="12">
                          <h4
                            className="mb-0 text-primary font-weight-bold"
                            style={{ fontSize: '1.2rem' }}
                          >
                            {group.name}
                          </h4>
                        </Col>
                      </Row>

                      <h6
                        className="text-muted mb-3"
                        style={{ fontSize: '0.7rem' }}
                      >
                        Perguntas da categoria:
                      </h6>

                      {group.questions.map((question, questionIndex) => {
                        const scoresFiltered = assessmentData.scores.filter(
                          (score) => score.question.id == question.id
                        );
                        let score =
                          scoresFiltered.length == 1 ? scoresFiltered[0] : null;

                        return (
                          <div key={question.id}>
                            <Row className="mb-3 ml-3">
                              <Col md="12" className="mb-3 text-center">
                                <span
                                  className="mr-2 font-weight-bold text-primary"
                                  style={{ fontSize: '0.95rem' }}
                                >
                                  Pergunta {questionIndex + 1}:
                                </span>
                                <span
                                  className="font-weight-400"
                                  style={{ fontSize: '0.9rem' }}
                                >
                                  {question.description}{' '}
                                  {question.required ? '*' : ''} (Peso{' '}
                                  {question.weightage})
                                </span>
                              </Col>
                              <Col
                                md="3"
                                className="d-flex justify-content-center mt-2"
                              >
                                <strong
                                  className="text-uppercase font-weight-600"
                                  style={{ fontSize: '0.85rem' }}
                                >
                                  Não Conforme
                                </strong>
                              </Col>
                              <Col md="6" className="mt-2">
                                <div className="d-flex justify-content-around">
                                  {renderQuestionInputs(question, score)}
                                </div>
                              </Col>
                              <Col
                                md="3"
                                className="d-flex justify-content-center mt-2"
                              >
                                <strong
                                  className="text-uppercase font-weight-600"
                                  style={{ fontSize: '0.85rem' }}
                                >
                                  Conforme
                                </strong>
                              </Col>
                            </Row>
                            {questionIndex < group.questions.length - 1 && (
                              <hr
                                className="my-2 mx-3"
                                style={{
                                  borderColor: '#dee2e6',
                                  opacity: 0.5
                                }}
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>
                  ))
                : assessmentData.paper.questions
                    ?.filter((q) => q.enabled)
                    .map((question) => {
                      const scoresFiltered = assessmentData.scores.filter(
                        (score) => score.question.id == question.id
                      );
                      let score =
                        scoresFiltered.length == 1 ? scoresFiltered[0] : null;

                      return (
                        <Row className="mb-5" key={question.id}>
                          <Col
                            md="12"
                            className="d-flex justify-content-center text-center mb-3"
                          >
                            <span
                              className="font-weight-400"
                              style={{ fontSize: '0.9rem' }}
                            >
                              {question.description}{' '}
                              {question.required ? '*' : ''} (Peso{' '}
                              {question.weightage})
                            </span>
                          </Col>
                          <Col
                            md="3"
                            className="d-flex justify-content-center mt-2"
                          >
                            <strong
                              className="text-uppercase font-weight-600"
                              style={{ fontSize: '0.85rem' }}
                            >
                              Não Conforme
                            </strong>
                          </Col>
                          <Col md="6" className="mt-2">
                            <div className="d-flex justify-content-around">
                              {renderQuestionInputs(question, score)}
                            </div>
                          </Col>
                          <Col
                            md="3"
                            className="d-flex justify-content-center mt-2"
                          >
                            <strong
                              className="text-uppercase font-weight-600"
                              style={{ fontSize: '0.85rem' }}
                            >
                              Conforme
                            </strong>
                          </Col>
                        </Row>
                      );
                    })}

              {assessmentData.feedback ? (
                <div
                  style={{
                    border: '1px solid #ccc',
                    borderRadius: '8px',
                    padding: '16px',
                    backgroundColor: '#f9f9f9',
                    marginTop: '10px'
                  }}
                >
                  <StyledStrong
                    style={{ marginBottom: '10px', display: 'block' }}
                  >
                    FEEDBACK REGISTRADO
                  </StyledStrong>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      flexWrap: 'wrap',
                      marginBottom: '10px'
                    }}
                  >
                    <span>
                      <strong>Autor:</strong>{' '}
                      {assessmentData.feedback.user?.name}
                    </span>
                    <span>
                      <strong>Data:</strong>{' '}
                      {new Date(
                        assessmentData.feedback.createdAt
                      ).toLocaleString()}
                    </span>
                  </div>

                  {assessmentData.feedback.description && (
                    <div>
                      <strong style={{ display: 'block', marginBottom: '5px' }}>
                        Descrição:
                      </strong>
                      <div
                        style={{
                          background: '#fff',
                          padding: '12px',
                          borderRadius: '4px',
                          border: '1px solid #ddd',
                          whiteSpace: 'pre-wrap'
                        }}
                      >
                        {assessmentData.feedback.description}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <>
                  {!showForm ? (
                    <button
                      onClick={() => setShowForm(true)}
                      style={{
                        backgroundColor: '#e0f7fa',
                        border: '1px solid #00acc1',
                        color: '#007c91',
                        padding: '10px 14px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontWeight: '500',
                        marginTop: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}
                    >
                      <i
                        className="fas fa-plus-circle"
                        style={{ fontSize: '16px' }}
                      ></i>
                      Adicionar Feedback
                    </button>
                  ) : (
                    <FeedbackForm
                      onSave={(newFeedback) => {
                        setAssessmentData((prev) => ({
                          ...prev,
                          feedback: newFeedback
                        }));
                        setShowForm(false);
                        if (onFeedbackSaved) {
                          onFeedbackSaved(newFeedback);
                        }
                      }}
                      assessmentId={assessmentId}
                    />
                  )}
                </>
              )}
            </Form>
          </div>
        )}
      </DefaultModal>
    </div>
  );
}
